import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../common/types';
import { Music24FullLogo } from '../../music24/components/Music24FullLogo';
import { presaveCreateMessages } from './presaveCreateMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole page; each part uses its own slice of it */
import styles from './PresaveCreate.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PresaveTopBarProps {
  /** The song title, when the screen is about one song. */
  title?: string;
  onClose: () => void;
}

/** The top bar of the pre-save screen (design presave-create a1): the brand, the crumb and Close. */
const PresaveTopBarComponent: React.FC<PresaveTopBarProps> = ({ title, onClose }) => {
  const intl = useIntl();
  return (
    <header className={styles.top}>
      <div className={styles.brand}>
        <Music24FullLogo size={22} />
      </div>
      <span className={styles.crumb}>
        {title === undefined
          ? intl.formatMessage(presaveCreateMessages.crumb)
          : intl.formatMessage(presaveCreateMessages.crumbSong, { title })}
      </span>
      <div className={styles.grow} />
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label={intl.formatMessage(presaveCreateMessages.close)}
        data-testid="presave-create-close"
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </header>
  );
};

export const PresaveTopBar = TypedMemo(PresaveTopBarComponent);
